<template>
  <div>
    <div v-if="loading" class="text-center pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p>Carregando dados do beneficiário...</p>
    </div>
    <div v-else-if="error" class="text-center pa-4">
      <v-alert type="error">
        Ocorreu um erro ao buscar os dados: {{ error.message }}
      </v-alert>
    </div>
    <div v-else-if="result && result.beneficiarioPorCpf === null" class="text-center pa-4">
      <v-alert type="warning">
        Beneficiário com o CPF fornecido não encontrado.
      </v-alert>
    </div>
    <div v-else-if="!cpf" class="text-center">
      <v-alert type="info">
        Por favor, acesse a aplicação através do link de redirecionamento.
      </v-alert>
    </div>
    <!-- Adicionado para verificar se o beneficiário é o titular -->
    <div v-else-if="result && result.beneficiarioPorCpf && result.beneficiarioPorCpf.ehTitular !== 'S'"
      class="text-center pa-4">
      <v-alert type="warning" prominent>
        A solicitação de reembolso só pode ser feita pelo titular do plano.
      </v-alert>
    </div>
    <div v-else-if="result && result.beneficiarioPorCpf && result.beneficiarioPorCpf.dataCancelamento"
      class="text-center pa-4">
      <v-alert type="warning" prominent>
        Solicitação de Reembolso indisponível.
      </v-alert>
    </div>
    <!-- Passa os dados do titular e a lista de familiares como props para o formulário -->
    <ReembolsoForm v-else-if="result && result.beneficiarioPorCpf" :titular="result.beneficiarioPorCpf"
      :familiares="familiaresResult?.familiaresPorTitularHandle || []" :familiares-loading="familiaresLoading"
      :data-solicitacao="result.dataAtual" />
  </div>
</template>

<script setup>
import { useQuery } from '@vue/apollo-composable';
import { gql } from '@apollo/client/core';
import { computed, ref, onMounted } from 'vue';
import ReembolsoForm from '@/ReembolsoForm.vue'

const cpf = ref(null);

onMounted(() => {
  cpf.value = localStorage.getItem('cpf_reembolso');
});

// Define a query GraphQL para buscar os dados
const GET_DATA_BY_CPF = gql`
  query GetData($cpf: String!) {
    dataAtual
    beneficiarioPorCpf(cpf: $cpf) {
      handle
      id
      benId
      cartao
      nome
      email
      celular
      ehTitular
      dataCancelamento
      matricula {
        handle
        cpf
      }
      enderecoCorrespondencia {
        logradouro
        numero
        bairro
        municipio {
          nome
        }
        estado {
          sigla
        }
      }
    }
  }
`;

// Executa a query para buscar o titular com o CPF do local storage
const { result, loading, error } = useQuery(
  GET_DATA_BY_CPF,
  () => ({
    cpf: cpf.value,
  }),
  { enabled: computed(() => !!cpf.value) } // A query só executa se o CPF existir
);

// Define a query para buscar os familiares
const GET_FAMILIARES_QUERY = gql`
  query GetFamiliares($titularHandle: ID!) {
    familiaresPorTitularHandle(titularHandle: $titularHandle) {
      handle
      id
      benId
      nome
      email
      celular
      matricula {
        cpf
      }
    }
  }
`;

// Executa a query de familiares, que depende do handle do titular
const { result: familiaresResult, loading: familiaresLoading } = useQuery(
  GET_FAMILIARES_QUERY,
  () => ({ titularHandle: result.value?.beneficiarioPorCpf?.handle }),

  { enabled: computed(() => !!result.value?.beneficiarioPorCpf?.handle) } // A query só executa se o handle do titular estiver disponível
);
</script>
